const holidays = [
    "01-01", // Nouvel An
    "05-01", // Fête du Travail
    "05-08", // Victoire 1945
    "07-14", // Fête Nationale
    "08-15", // Assomption
    "11-01", // Toussaint
    "11-11", // Armistice 1918
    "12-25"  // Noël
  ];
function ngayGiaoHang() {

  let thoiDiemHienTai = new Date();


 
    console.log(thoiDiemHienTai.getDay())
    if (thoiDiemHienTai.getDay() == 5 && thoiDiemHienTai.getHours() > 13) {

     thoiDiemHienTai.setDate(thoiDiemHienTai.getDate() + ((1 + 7 - thoiDiemHienTai.getDay()) + 2));

    } else if (thoiDiemHienTai.getDay() == 5 && thoiDiemHienTai.getHours() < 13) {
      thoiDiemHienTai.setDate(thoiDiemHienTai.getDate() + 3);
    }
    else if (thoiDiemHienTai.getDay() == 6 ) {
      thoiDiemHienTai.setDate(thoiDiemHienTai.getDate() + ((1 + 7 - thoiDiemHienTai.getDay()) + 2));
      
    }else if (thoiDiemHienTai.getDay() == 0 ) {
  
     thoiDiemHienTai.setDate(thoiDiemHienTai.getDate() + 3);

    } else {
  
      thoiDiemHienTai.setDate(thoiDiemHienTai.getDate() + 2);
    
    }




  const monthMap = {
    1: "janvier",
    2: "février",
    3: "mars",
    4: "avril",
    5: "mai",
    6: "juin",
    7: "juillet",
    8: "août",
    9: "septembre",
    10: "octobre",
    11: "novembre",
    12: "décembre"
  };


  const ngayGiaoHang = thoiDiemHienTai.getDate().toString().padStart(2, '0');
  const thangGiaoHang = thoiDiemHienTai.getMonth() + 1;
  const tenThangGiaoHang = monthMap[thangGiaoHang];


  const formattedDate = `${thangGiaoHang}-${ngayGiaoHang}`;


  if (holidays.includes(formattedDate)) {
  
    thoiDiemHienTai.setDate(thoiDiemHienTai.getDate() + 1);
  }
  const dynamicDeliveryDate2 = document.querySelectorAll('.product-detail__form__action__delivery-date');
  dynamicDeliveryDate2.forEach((date)=>{
    date.innerText =`${ngayGiaoHang} ${tenThangGiaoHang}`; 
  });

}




function setCountdown() {
  ngayGiaoHang();
      // Liste des jours fériés en France
  const holidays = [
    "01-01", // Nouvel An
    "05-01", // Fête du Travail
    "05-08", // Victoire 1945
    "07-14", // Fête Nationale
    "08-15", // Assomption
    "11-01", // Toussaint
    "11-11", // Armistice 1918
    "12-25"  // Noël
  ];
  
    let daysToAdd = 2;
    let thoiDiemHienTai = new Date();


  if (thoiDiemHienTai.getHours() < 13) {

    thoiDiemHienTai.setDate(thoiDiemHienTai.getDate() + daysToAdd);
  } else {

    if (thoiDiemHienTai.getDay() >= 5 && thoiDiemHienTai.getDay() <= 0) {
 
      thoiDiemHienTai.setDate(thoiDiemHienTai.getDate() + ((1 + 7 - thoiDiemHienTai.getDay()) + daysToAdd));
    } else {
   
      thoiDiemHienTai.setDate(thoiDiemHienTai.getDate() + daysToAdd);
    }
  }


  const formattedDate = (thoiDiemHienTai.getMonth() + 1).toString().padStart(2, '0') + "-" +
                         thoiDiemHienTai.getDate().toString().padStart(2, '0');


  if (holidays.includes(formattedDate)) {
   
    thoiDiemHienTai.setDate(thoiDiemHienTai.getDate() + 1);
  }

  const shipDay = thoiDiemHienTai.getDate().toString().padStart(2, '0');
  const shipMonth = (thoiDiemHienTai.getMonth() + 1).toLocaleString('default', { month: 'long' });
  // const dynamicDeliveryDate2 = document.querySelectorAll('.product-detail__form__action__delivery-date');
  // dynamicDeliveryDate2.forEach((date)=>{
  //   date.innerText =`${shipMonth}-${shipDay}`; 
  // });
  // Liste des jours fériés en France

  
  // Fonction pour ajouter un nombre de jours à une date donnée
  function addDays(date, days) {
    const result = new Date(date);
    result.setDate(result.getDate() + days);
    return result;
  }
  
  // Fonction pour vérifier si une date est un dimanche
  function isSunday(date) {
    return date.getDay() === 0;
  }
  
  // Fonction pour vérifier si une date est un jour férié en France
  function isHoliday(date) {
    const day = date.getDate();
    const month = date.getMonth() + 1;
    const holiday = `${day < 10 ? "0" : ""}${day}-${month < 10 ? "0" : ""}${month}`;
    return holidays.includes(holiday);
  }
  
  // Fonction pour calculer la date de 2 jours plus tard en excluant les dimanches et les jours fériés
  function calculateDate() {
    let date = new Date();
    let daysToAdd = 2;
    
    while (daysToAdd > 0) {
      date = addDays(date, 1);
      if (!isSunday(date) && !isHoliday(date)) {
        daysToAdd--;
      }
    }
    
    const day = date.getDate();
    const month = date.toLocaleString('default', { month: 'long' });
    const year = date.getFullYear();
    
    return `${day < 10 ? "0" : ""}${day} ${month < 10 ? "0" : ""}${month}`;
  }
  
  function calculateFrenchWay(){
    let date = new Date();
    let daysToAdd = 2;
    
    while (daysToAdd > 0) {
      date = addDays(date, 1);
      if (!isSunday(date) && !isHoliday(date)) {
        daysToAdd--;
      }
    }
    
    const day = date.getDate();
    const month = date.getMonth() + 1;
    const year = date.getFullYear();
    // Obtenir le nom du jour de la semaine
    const joursSemaine = ['dimanche', 'lundi', 'mardi', 'mercredi', 'jeudi', 'vendredi', 'samedi'];
    const nomJour = joursSemaine[date.getDay()];
  
    // Obtenir le mois et l'année
    const mois = date.toLocaleString('default', { month: 'long' });
    const annee = date.getFullYear();
  
    // Concaténer les éléments dans la chaîne de caractères résultante
    const dateConvertie = `${nomJour} ${day} ${mois} ${annee}`;
  
    // Retourner la date convertie
    return dateConvertie;
  }
// Utilisation de la fonction pour calculer la date de 2 jours plus tard en excluant les dimanches et les jours fériés
const dateLivraison = calculateDate();

  // const dynamicDeliveryDate = document.querySelectorAll('.under-cart-dynamic-date');
  // dynamicDeliveryDate.forEach((date)=>{
  //   date.innerText = dateLivraison;
  // });







function elementInViewport2(el) {
  var top = el.offsetTop;
  var height = el.offsetHeight;

  while (el.offsetParent) {
      el = el.offsetParent;
      top += el.offsetTop;
  }
  return (
      top < (window.pageYOffset + window.innerHeight) &&
      (top + height) > window.pageYOffset
  );
}


  if(document.querySelector('.cart-counter') == null) return;
  // Compteur titre
  // Définir la durée du compte à rebours en secondes
    var duration = 15 ;

    // Obtenir les éléments du DOM
    var minutesLabel = document.querySelector(".cart-counter-minutes");
    var secondsLabel = document.querySelector(".cart-counter-seconds");
  
function resetStartTime() {
  const startTime = Date.now();
  const eventTime = duration * 60 * 1000;
  const eventDuration = new Date(startTime + eventTime);
  // Save to localstorage
  window.localStorage.setItem("startTime", eventDuration);
  return eventDuration;
}
    const startTime = new Date(
    window.localStorage.getItem("startTime") || resetStartTime()
  );
  
    // Mettre à jour le compte à rebours chaque seconde
    var timeInterval = setInterval(function() {
          const timer = startTime.getTime() - Date.now();
      // Calculer les minutes et les secondes restantes
    const minutes = Math.floor((timer % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((timer % (1000 * 60)) / 1000);

      // Afficher les minutes et les secondes dans le DOM
      minutesLabel.innerHTML = minutes;
      secondsLabel.innerHTML = seconds;


      // Arrêter le compte à rebours lorsque la durée atteint 0
      console.log('timer',timer);
      if (timer < 0) {
        
 window.localStorage.removeItem("startTime");
         minutesLabel.innerHTML = "0";
      secondsLabel.innerHTML = "00";
// const removeButtons = document.querySelectorAll('.cart-remove-button');
//         fetch(window.Shopify.routes.root + 'cart/clear.js', {
//           method: 'POST'
//         });
//         location.reload();
        //cart-clear js
        fetch(window.Shopify.routes.root + 'cart/clear.js', {
          method: 'POST'
        })
          .then(response => {
            return response.json();
          })
          .then(data => {
            location.reload();
          })
          .catch(error => {
            console.error('Error:', error);
          });
        clearInterval(timeInterval);
      }
    }, 1000);
  
}

class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
    
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');

  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);
